import React from 'react';
import { View, Text, StyleSheet } from 'react-native-web';
import PropTypes from 'prop-types';
import { Success } from 'Icons/Icons';

interface PropsType {
    success: string;
    style?: React.CSSProperties;
    textStyle?: React.CSSProperties;
    successIcon?: boolean;
}

const SuccessMessage = (props: PropsType): JSX.Element | null => {
    const { success, style, textStyle, successIcon } = props;

    if (!success) return null;

    return (
        <View style={[styles.container, style]}>
            {successIcon && <Success />}
            <Text style={[styles.successText, textStyle]} numberOfLines={3}>
                {success}
            </Text>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        marginVertical: 5,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5,
    },
    successText: {
        color: '#6CC271',
        fontSize: 13,
        textAlign: 'center',
    },
});

SuccessMessage.propTypes = {
    success: PropTypes.string,
    style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
};

SuccessMessage.defaultProps = {
    success: '',
    style: {},
    textStyle: {},
    successIcon: false,
};

export default SuccessMessage;
